module.exports = __webpack_public_path__ + "static/media/gbp.cd34f235.svg";